<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-item-use-comfirm-modal']"
   :additionalZIndex="3"
   :isOpen="isModalOpen"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @afterEnterContent="handleAfterEnterContent"
   @closeOverlayModal="handleCloseOverlay"
  >
    <PaWideModalBox
     ref="wideModalComponent"
     :itemImageName="infomation.itemSlug"
     :confirmButtonText="'アイテムを使用して続ける'"
     :isSubmitLoading="isSubmitLoading"
     :isDisabledSubmit="isDisabledSubmitButton"
     :lineMessage="lineMessage"
     @handleSubmit="handleClickSubmitButton"
     @handleCancel="handleClickCancelButton"
    >
      <template v-slot:title>{{infomation.title}}</template>
      <template v-slot:description>{{infomation.description}}</template>
      <template v-slot:caption>{{infomation.itemStatus}}</template>
    </PaWideModalBox>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PaWideModalBox from '@/components/Parts/PAWideModalBox/PAWideModalBox.vue'

export default {
  components : {
    PaOverlayModal,
    PaWideModalBox
  },

  data(){
    return {
      isFreezModal : false
    };
  },

  computed : {
    isModalOpen(){
      return this.$store.state.itemUseModal.isOpenModal;
    },

    infomation(){
      return this.$store.state.itemUseModal.infomation;
    },

    isSubmitLoading(){
      return this.$store.state.itemUseModal.isSubmitLoading;
    },

    isDisabledSubmitButton(){
      return this.$store.state.itemUseModal.isDisabledSubmitButton;
    },

    handleSubmitFunction(){
      return this.$store.state.itemUseModal.handleSubmitFunction;
    },

    handleCancelFunction(){
      return this.$store.state.itemUseModal.handleCancelFunction;
    },

    lineMessage(){
      return this.$store.state.itemUseModal.lineMessage;
    }
  },

  methods : {
    handleAfterEnterContent(){
      const actualHeight = window.innerHeight - ((window.innerHeight * .1) * 2);

      const boxHeight = this.$refs.wideModalComponent.$refs.wideModalBox.offsetHeight;
      
      if(boxHeight > actualHeight){
        this.$refs.wideModalComponent.$refs.wideModalBox.style.height = actualHeight + 'px';
      }
    },

    handleSubmit(){
      if(typeof this.handleSubmitFunction === 'function'){
        this.handleSubmitFunction();
      }
    },

    handleCancel(){
      if(typeof this.handleCancelFunction === 'function'){
        this.handleCancelFunction();
      }
    },

    handleCloseOverlay(){
      this.handleCancel();
    },

    handleClickSubmitButton(){
      this.handleSubmit();
    },

    handleClickCancelButton(){
      this.handleCancel();
    }
  }
}
</script>

<style lang="scss">
.pa-item-use-comfirm-modal{
 .pa-wide-modal-box{
    overflow-y: scroll;
  }
}
</style>